export default __webpack_public_path__ + "static/media/flashsalemobile1024.de67edf0.png";